import { IGetColetaPrecoDropDownUseCase } from "../../../presentation/useCases/read/get_coleta_preco_drop_down_use_case";
import { ColetaPrecoDropDown } from "../../models/coleta_preco_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetColetaPrecoDropDownUseCase
 */

export class GetColetaPrecoDropDownUseCase implements IGetColetaPrecoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getColetaPrecoDropDown(
  ): Promise<ColetaPrecoDropDown[]> {
    return await this.repository.getColetaPrecoDropDown();
  }
}
